import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, false = anonymous, object = authenticated
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try { const u = await api.me(); setUser(u); return u; } catch { setUser(false); return false; }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback handles the session exchange first.
    if (window.location.hash?.includes('session_id=')) { setUser(false); return; }
    refresh();
  }, [refresh]);

  const logout = async () => { try { await api.logout(); } catch (e) { console.warn('[auth] server logout failed, clearing local session anyway', e); } setUser(false); };

  return <AuthContext.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
